import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ExToParkLanding from "./components/eztoparkLanding";
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ExToParkLanding />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
